var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.333 9.667a5 5 0 0 1 5-5v1a5 5 0 0 1-4.11 4.92l1.901-2.716a.341.341 0 0 0-.56-.392l-2.23 3.188v2.666h-.667v-2.666L5.435 7.479a.341.341 0 1 0-.559.391l1.901 2.716a5 5 0 0 1-4.11-4.92v-1a5 5 0 0 1 5 5v1h.666v-1ZM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm.022 15.022a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    fill: "#0E111D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/vegan.28f7c20d759797833c26083b8b56ec03.svg";
export { ForwardRef as ReactComponent };